<template>
  <div id="app">
   <MainPage :shows="shows"/>
  </div>
</template>

<script>
import MainPage from './components/MainPage.vue'

export default {
  name: 'App',
  components: {
    MainPage
  },
  data() {
    return {
      shows: [],
    }
  },
  mounted() {
    fetch("https://api.jsonbin.io/v3/b/6586262ddc74654018878ef3")
      .then(response => response.json())
      .then(data => {
        this.shows = data.record.shows;
      })
      .catch(error => console.log(error))
  },
}
</script>

<style>

@font-face {
  font-family: 'BNAxelGroteskBold';
  src: url('./assets/fonts/BNAxelGrotesk-Bold.woff') format('woff');
}

@font-face {
  font-family: 'BobbiTheHippie';
  src: url('./assets/fonts/BobbiTheHippie.woff') format('woff');
}

@font-face {
  font-family: 'EditorialNewVariable';
  src: url('./assets/fonts/EditorialNew-Variable.woff') format('woff');
}


@font-face {
  font-family: 'NeueMontrealBold';
  src: url('./assets/fonts/NeueMontreal-Bold.woff') format('woff');
}

@font-face {
  font-family: 'NeueMontrealRegular';
  src: url('./assets/fonts/NeueMontreal-Regular.woff') format('woff');
}

body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  background: #f06825;
}

#app {
  background: #f06825;
  overflow-x: hidden;
}
</style>
